export const URLs = {
  SAVE_PRODUCT_LEAD: '/product/demo-requests',
  SAVE_AUCTION_EXTENSION_REQUEST: '/auction-extension/request',
  GET_QUOTA_DETAILS: '/quota/fetchDetails?userId=',
  RESET_PASSWORD: '/user/reset-password',
  FORGOT_PASSWORD: '/user/forgot-password',
  GET_LF_VARIABLES: '/loading-factor/get-lf-variables',
  SAVE_ITEM_BID: '/bidder/saveItemBid',
  GET_BIDDERS_RANK_FOR_AUCTIONEER: '/bidder/get/auction/ranks',
  GET_ITEM_BID_DETAILS: '/bidder/item/bidDetails',

  // main urls of auction service
  AUCTION_API: '/api/v1/ranks',
  BIDDER_RANK: '/get/bidder/rank',
  GET_BIDDERS_RANKS_FOR_AUCTIONEER: '/get/auction/ranks',
  AUCTION_COUNT_BY_CATEGORY: '/dashboard/auction-numbers-by-category',
};
